// @ts-nocheck

export type StoriesListStatus =
  typeof StoriesListStatus[keyof typeof StoriesListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StoriesListStatus = {
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
  GENERATING: "GENERATING",
  PENDING: "PENDING",
} as const;
